/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';
import $ from 'jquery';
import { Modal } from 'react-bootstrap';
import Parser from 'html-react-parser';
import CartForm from './CartForm';
import SavedItems from './SavedItems';
import {Loader} from '../../Helpers/Helpers';
import ReactPixel from 'react-facebook-pixel';

const ajaxurl = Constants.URL.root+'/wp-admin/admin-ajax.php';

export default class AddToCart extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			addFav: null,
			lgShow: false,
			show: false,
			cartShow: false,
			favLoading: false,
			compare1Selection: 0,
			compare2Selection: 1,
			savedItems: [],
			cartLoading: false,
			cartContent: null
        }
	    this.addToCart = this.addToCart.bind(this);
	    this.quickSave = this.quickSave.bind(this);
	    this.addToFav = this.addToFav.bind(this);
	    this.lgClose = this.lgClose.bind(this);
	    this.lgHide = this.lgHide.bind(this);
	    this.handleChange1 = this.handleChange1.bind(this);
	    this.handleChange2 = this.handleChange2.bind(this);
	    this.manageView = this.manageView.bind(this);
	    this.openFramesTab = this.openFramesTab.bind(this);
	    this.removeFrame = this.removeFrame.bind(this);
  	}

    lgClose = () => this.setState({ lgShow: false });
    lgHide = () => this.setState({ show: false });
    cartHide = () => this.setState({ cartShow: false });

    openFramesTab() {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedTab: 'frames'
			}
		})
    }

    removeFrame() {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedFrame: [],
				frameTotal: 0,
				matsUpdated: this.props.matsUpdated === 1 ? 0 : 1,
				selectedGlass: 362,
				glassTotal: 0,
				selectedGlassName: 'None'
			}
		})
    }

  	addToCart() {
  		// Update QTY
  		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				cartQty: parseFloat(this.props.qty) + parseFloat(this.props.cartQty),
				customizeQTY: parseFloat(this.props.qty)
			}
		});
		var self = this;
  		self.setState({cartLoading: true});
  		const {cart1ItemTotal} = this.props;
  		// Add to cart
		$.ajax(ajaxurl, {
			method: "POST",
			dataType: 'json',
			data: $('.cartForm').serialize()+'&action=add_item_to_cart&cartTotal='+cart1ItemTotal,
			success: function (res) {
				self.setState({cartContent: res.message, cartShow: true, cartLoading: false});
				ReactPixel.track( 'AddToCart' );
			}
		});
  	}

  	addToFav() {
  		var self = this;
  		self.setState({favLoading: true});
		const {cart1ItemTotal} = this.props;
  		$.ajax(ajaxurl, {
			method: "POST",
			data: $('.cartForm').serialize()+'&action=add_to_favourites_mat_boards&cartTotal='+cart1ItemTotal,
			success: function (res) {
				self.setState({addFav: res, lgShow: true, favLoading: false});
			}
		});
	}

  	quickSave() {
  		var res = true;
		const {savedItems} = this.state;
		const {selectedmatBoard, selectedFrame, selectedTopMat, selectedMiddleMat, middleMatTotal, frameTotal, glassTotal, selectedGlassName, selectedGlass, printTotal, selectedPrintName, selectedPrint, cart1ItemTotal, selectedMatSize, canvasImage, canvasThumbImage, qty, frameSizeH, frameSizeW, middleMatGapInCM, windowDimensionW, windowDimensionH, windowsFullDimension, matBoardPrice} = this.props;
		if (savedItems.length > 0) {
	  		savedItems.forEach(item => {
	  			if ( parseFloat(selectedmatBoard.get('id')) !== parseFloat(item.selectedmatBoard.get('id')) || parseFloat(selectedFrame.get('id')) !== parseFloat(item.selectedFrame.get('id')) || selectedTopMat !== item.selectedTopMat || selectedMiddleMat !== item.selectedMiddleMat || selectedGlass !== item.selectedGlass || selectedPrint !== item.selectedPrint || selectedMatSize !== item.selectedMatSize ) {
			        res = true
			    } else {
			    	res = false
			    }
			});
  		}
		if ( res === true ) {
			savedItems.push({
	            selectedFrame,
	            frameTotal,
	            frameSizeH,
	            frameSizeW,
	            selectedTopMat,
	            selectedMiddleMat,
	            middleMatTotal,
	            selectedMatSize,
	            selectedGlass,
	            glassTotal,
	            selectedGlassName,
	            selectedPrint,
	            printTotal,
	            selectedPrintName,
	            cart1ItemTotal,
	            canvasImage,
	            canvasThumbImage,
	            qty,
	            selectedmatBoard,
	            middleMatGapInCM,
	            windowDimensionW,
	            windowDimensionH,
	            windowsFullDimension,
	            matBoardPrice
	        });
	        this.setState({ savedItems })
		}
  	}

  	deleteArray = (array) => {
		var arrayFinal = this.state.savedItems.filter(function(item, key) {
			return key !== parseFloat(array)
		});
		this.setState({ savedItems: arrayFinal })
		this.manageView(arrayFinal);
  	}

  	manageView = (array) => {
  		const {compare1Selection, compare2Selection} = this.state;
  		if (array.length <= parseFloat(compare1Selection)) {
  			this.setState({ compare1Selection: array.length - 1 })
  		}
		if (array.length <= parseFloat(compare2Selection)) {
  			this.setState({ compare2Selection: array.length - 1 })
  		}
  	}

  	editSaved = (array) => {
  		const {savedItems} = this.state;
  		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedFrame: savedItems[array].selectedFrame,
				selectedTopMat: savedItems[array].selectedTopMat,
				selectedMiddleMat: savedItems[array].selectedMiddleMat,
				middleMatTotal: savedItems[array].middleMatTotal,
				selectedMatSize: savedItems[array].selectedMatSize,
				selectedGlass: savedItems[array].selectedGlass,
				glassTotal: savedItems[array].glassTotal,
				selectedGlassName: savedItems[array].selectedGlassName,
				selectedPrint: savedItems[array].selectedPrint,
				printTotal: savedItems[array].printTotal,
				selectedPrintName: savedItems[array].selectedPrintName,
				cart1ItemTotal: savedItems[array].cart1ItemTotal,
				canvasImage: savedItems[array].canvasImage,
				qty: savedItems[array].qty,
				frameTotal: savedItems[array].frameTotal,
				frameSizeH: savedItems[array].frameSizeH,
	            frameSizeW: savedItems[array].frameSizeW,
				selectedmatBoard: savedItems[array].selectedmatBoard,
	            middleMatGapInCM: savedItems[array].middleMatGapInCM,
	            windowDimensionW: savedItems[array].windowDimensionW,
	            windowDimensionH: savedItems[array].windowDimensionH,
	            windowsFullDimension: savedItems[array].windowsFullDimension,
	            matBoardPrice: savedItems[array].matBoardPrice,
			}
		})
		this.setState({ show: false })
  	}

	handleChange1(event) {
    	this.setState({ compare1Selection: event.target.value });
  	}

  	handleChange2(event) {
    	this.setState({ compare2Selection: event.target.value });
  	}

	render() {
		const {savedItems, compare1Selection, compare2Selection} = this.state;
		const {selectedmatBoard, selectedFrame} = this.props;
        const selectOptions = [];
       	for (let i = 0; i < savedItems.length; i++) {
	        selectOptions.push(<option key={i} value={i}>{i+1}</option>);
	    }
	    return (
			<div>
				{this.props.imageSizeError || this.props.qty === '' ?
					<div className='alert alert-danger m-b-5 p-b-9 p-t-9'>Please correct the errors and try again!</div> :
					<div className="cont_rgt_btn">
						{selectedmatBoard.size > 0 ?
							<ul>
								<li className="m-b-5">
									<CartForm
										{...this.props}
										btnText='Buy now' />
								</li>
								<li className="m-b-5">
									{selectedFrame.size === 0 ?
										<a href="#!" className="btn btn-primary default-btn frame-it-btn" onClick={this.openFramesTab}>Frame It</a>
										:
										<a href="#!" className="btn btn-primary default-btn text-upper frame-it-btn" onClick={this.removeFrame}>Remove Frame</a>
									}
								</li>
								<li className="m-b-5">
									<a href="#!" className="btn btn-primary default-btn single_add_to_cart_button" onClick={this.addToCart}>
										{this.state.cartLoading ?
											<div className="loading"></div> :
											<span>Add to cart</span>
										}
									</a>
									<GetCartPopOver
										cartShow={this.state.cartShow}
										cartHide={this.cartHide}
										cartContent={this.state.cartContent} />
								</li>
								{/* <li className="m-b-5">
									<a href="#!" className="btn btn-primary default-btn" onClick={this.quickSave}>Quick save</a>
								</li> */}
								<li className="m-b-5">
									<a href="#!" className="btn btn-primary default-btn" onClick={this.addToFav}>
										{this.state.favLoading ?
											<div className="loading"></div> :
											<i className="far fa-heart"></i>
										}
									</a>
									<GetFavModal
										lgShow={this.state.lgShow}
										lgClose={this.lgClose}
										addFav={this.state.addFav} />
								</li>
							</ul>
							:
							<div className="loadingSecButton">
								<Loader />
							</div>
						}
					</div>
				}
				{/* <div className="cont_rgt_saved">
					<p>Saved: {savedItems.length > 0 ? savedItems.length : 0 }</p>
					<a href="#!" onClick={() => this.setState({ show: true })}>View/Compare</a>
					<Modal
						show={this.state.show}
						onHide={this.lgHide}
						bsSize="large"
					>
						<Modal.Header closeButton>
				        	<Modal.Title id="contained-modal-title-lg">View Compare</Modal.Title>
				        </Modal.Header>
				        {savedItems.length <= 1 ?
				        	<Modal.Body>
								<div className="alert alert-danger">Please quick save atleast two items to compare!</div>
							</Modal.Body>
				        	:
				        	<Modal.Body>
								<div className="row view-compare-outer">
									<div className="col-sm-6">
										<select className="col-sm-12" value={compare1Selection} onChange={this.handleChange1}>
								        	{selectOptions}
								        </select>
								        <SavedItems
								        	{...this.props}
								        	savedItems={savedItems}
								        	deleteArray={this.deleteArray}
								        	editSaved={this.editSaved}
								        	viewArray={compare1Selection} />
									</div>
									<div className="col-sm-6">
										<select className="col-sm-12" value={compare2Selection} onChange={this.handleChange2}>
								        	{selectOptions}
								        </select>
								        <SavedItems
								        	{...this.props}
								        	savedItems={savedItems}
								        	deleteArray={this.deleteArray}
								        	editSaved={this.editSaved}
								        	viewArray={compare2Selection} />
									</div>
								</div>
							</Modal.Body>
				        }
					</Modal>
				</div> */}
			</div>
	    );
	}
}

class GetCartPopOver extends Component {
	render() {
		return (
			<Modal
				show={this.props.cartShow}
				onHide={this.props.cartHide}
			>
				<Modal.Header closeButton>
		        	<Modal.Title id="contained-modal-title-lg">Cart</Modal.Title>
		        </Modal.Header>
				<Modal.Body>
					{this.props.cartContent !== null ? Parser(this.props.cartContent) : ''}
				</Modal.Body>
			</Modal>
		)
	}
}

class GetFavModal extends Component {
	render() {
		return (
			<Modal
				show={this.props.lgShow}
				onHide={this.props.lgClose}
			>
				<Modal.Header closeButton>
		        	<Modal.Title id="contained-modal-title-lg">Favourites</Modal.Title>
		        </Modal.Header>
				<Modal.Body>
					{this.props.addFav !== null ? Parser(this.props.addFav) : ''}
				</Modal.Body>
			</Modal>
		)
	}
}